import { makeStyles, TextareaAutosize } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: "14px",
    color: "#464e5f",
  },
  desc: {
    fontSize: "13px",
    background: "#eeeeef",
    marginBottom: theme.spacing(1.2),
    marginTop: theme.spacing(1.2),
    padding: theme.spacing(1),
    border: "1px solid #eeeeef",
    color: "#6C7293",
  },
}));
const WhatIsTag = () => {
  const classes = useStyles();
  return (
    <div className="d-flex flex-column ml-n5">
      <div className="mb-4">
        <span className={`d-block ${classes.title}`}>
          Tags are optional and could be used to emphasize any sentence, adding
          pauses, setting pitch etc. in the “Text to be Converted”.
        </span>
      </div>

      <div>
        <span className={`d-block ${classes.title} mb-1 mt-3`}>
          Pause between Paragraphs
        </span>
        <span className={`d-block ${classes.desc}`}>
          {`<p>This tag will provide a pause between the paragraphs.</p>`}
        </span>
      </div>

      <div>
        <span className={`d-block ${classes.title} mb-1 mt-3`}>
          Pause between Sentences
        </span>
        <span className={`d-block ${classes.desc}`}>
          {`<s>This tag will provide a pause between the sentences.</s>`}
        </span>
      </div>

      <div>
        <span className={`d-block ${classes.title} mb-1 mt-3`}>
          Emphasis Level (Set as strong, moderate, reduced)
        </span>
        <span className={`d-block ${classes.desc}`}>
          {`<emphasis level='strong'>I am emphasizing</emphasis>`}
        </span>
      </div>

      <div>
        <span className={`d-block ${classes.title} mb-1 mt-3`}>
          Pitch (Set from -10% to 10%, default is 0%)
        </span>
        <span className={`d-block ${classes.desc}`}>
          {`<prosody pitch='-10%'>with a somewhat lower pitch?</prosody>`}
        </span>
      </div>

      <div>
        <span className={`d-block ${classes.title} mb-1 mt-3`}>Telephone</span>
        <span className={`d-block ${classes.desc}`}>
          {`<say-as interpret-as='telephone'>2122241555</say-as>`}
        </span>
      </div>

      <div>
        <span className={`d-block ${classes.title} mb-1 mt-3`}>Dates</span>

        <span
          className={`d-block ${classes.desc}`}
          style={{ whiteSpace: "pre" }}>
          <TextareaAutosize
            disabled
            style={{
              overflow: "auto",
              width: "100%",
              background: "transparent",
              border: "none",
            }}
            placeholder={`<say-as interpret-as='date' format='dmy'>12-31-1900</say-as>
  format can be:
  mdy: Month-day-year
  dmy: Day-month-year
  ymd: Year-month-day
  md: Month-day
  dm: Day-month
  ym: Year-month
  my: Month-year"`}
          />
        </span>
      </div>
    </div>
  );
};

export default WhatIsTag;
